import { Position, Toaster } from '@blueprintjs/core';

import '@blueprintjs/core/lib/css/blueprint.css';

const FlashMessage = Toaster.create({
  className: 'flash_message',
  position: Position.TOP_CENTER
});

export default FlashMessage;
